/// <amd-module name="TFS/NetPromoterSurvey/Components/SubmissionDetail" />
import * as React from "react";

import { Dropdown, IDropdownOption } from "OfficeFabric/Dropdown";
import { Label } from "OfficeFabric/Label";
import * as NetPromoterSurveyResources from "TFS/NetPromoterSurvey/Resources";
import { Button } from "VSSUI/Button";
import { Checkbox } from "VSSUI/Checkbox";
import { Link } from "VSSUI/Link";
import { TextField } from "VSSUI/TextField";

export interface SubmissionDetailProps {
    reasonLabel: string;
    roleLabel: string;
    roleList: string;
    rolePlaceholder: string;
    hideContactConsented?: boolean;
    contactConsentedLabel: string;
    privacyText: string;
    privacyUrl: string;
    submitDisabled?: boolean;

    reason?: string;
    role?: string;
    contactConsented?: boolean;

    onChange(value: { [key: string]: string | boolean }): void;
    onSubmit(): void;
}

export const SubmissionDetail: React.SFC<SubmissionDetailProps> = props => {
    const options = props.roleList.split(",").map(role => {
        return { key: role, text: role };
    });
    return (
        <div>
            <Label className="fontSizeM fontWeightSemiBold">{props.reasonLabel}</Label>
            <TextField
                className="nps-dialog-reason"
                multiline
                rows={3}
                resizable={false}
                value={props.reason}
                onChange={(event, reason) => {
                    props.onChange({ reason: reason });
                }}
            />
            <Dropdown
                calloutProps={{ directionalHintFixed: false }}
                label={props.roleLabel}
                placeholder={props.rolePlaceholder}
                options={options}
                selectedKey={props.role}
                onChanged={(item: IDropdownOption) => {
                    props.onChange({ role: item.key.toString() });
                }}
            />
            {!props.hideContactConsented && (
                <Checkbox
                    className="nps-contact-consented-checkbox"
                    label={props.contactConsentedLabel}
                    checked={!!props.contactConsented}
                    onChange={(ev: any, isChecked: boolean) => {
                        props.onChange({ contactConsented: isChecked });
                    }}
                />
            )}
            <div className="flex-row nps-dialog-footer">
                <Link className="flex-grow flex-self-center" target="_blank" href={props.privacyUrl}>
                    {props.privacyText}
                </Link>
                <Button primary={true} onClick={props.onSubmit} text={NetPromoterSurveyResources.SubmitLabel} disabled={props.submitDisabled} />
            </div>
        </div>
    );
};
